import React, { useEffect, useState } from "react";
import { Modal, Image, Form } from "react-bootstrap";
import { Icon } from "@iconify/react";
import homeIcon from "../assets/img/homeIcon.png";
import compliantIcon from "../assets/img/compliantIcon.png";
import interiordesignerIcon from "../assets/img/interior-designerIcon.png";
import paymentIcon from "../assets/img/paymentIcon.png";
import kitchenIcon from "../assets/img/bathroom.svg";
import projectDescIcon from "../assets/img/projectDescIcon.png";
import { Link } from "react-router-dom";
import { revokePreviewUrls } from "../utils/photoPreview";
import { ClickablePhoto, usePhotoLightbox } from "./PhotoLightbox";

const KitchenModal = ({ Kitchen, KitchenToggle, StepcompleteNext }) => {
  const [step, setStep] = useState(1);
  const [responses, setResponses] = useState({}); // Store selections for each step
  const totalSteps = 5;
  const [isNextDisabled, setIsNextDisabled] = useState(true);
  const [description, setDescription] = useState("");
  const [descriptionError, setDescriptionError] = useState(false);
  const [file, setFile] = useState(null);
  const [error, setError] = useState("");
  const { openLightbox, closeLightbox } = usePhotoLightbox();
  useEffect(() => {
    setIsNextDisabled(!responses[step]); // Disable if no response exists
  }, [step, responses]);
  const submitBtn = () => {
    StepcompleteNext(responses, file,description);
  }

  const handleYesNoClick = (response) => {
    var question = "";
    // if (step == 1) {
    //   question = "master";
    // }
    if (step == 1) {
      question = "architecturalplansordrawings";
    }
    if (step == 2) {
      question = "buildingpermit";
    }
    if (step == 3) {
      question = "workingwithdesigner";
    }
    if (step == 4) {
      question = "sellinghome";
    }
    setResponses({ ...responses, [step]: response, [question]: response });
    setError(""); // Clear error when user selects an option
    setIsNextDisabled(false);
  };

  const [preview, setPreview] = useState(null);


  const handleRemoveImage = () => {
    if (preview) revokePreviewUrls([preview]);
    setPreview(null);
    setFile(null);
  };

  const assignArchitecturalFile = (uploadedFile) => {
    if (!uploadedFile) return;
    if (preview) revokePreviewUrls([preview]);
    setFile(uploadedFile);
    setPreview(URL.createObjectURL(uploadedFile));
    setError("");
  };

  const handleDropArchitectural = (event) => {
    event.preventDefault();
    const uploadedFile = event.dataTransfer.files?.[0];
    if (uploadedFile?.type.startsWith("image/")) {
      assignArchitecturalFile(uploadedFile);
    }
  };

  const handleFileChange = (event) => {
    assignArchitecturalFile(event.target.files[0]);
    event.target.value = "";
  };

  const handleNext = () => {
    // Ensure user selects Yes or No before proceeding
    if (!responses[step]) {
      setError("Please select Yes or No before proceeding.");
      return;
    }

    // Ensure file upload if "Yes" is selected on step 2
    if (step === 1 && responses[step] === "yes" && !file) {
      setError("Please upload a photo before proceeding.");
      return;
    }

    setError(""); // Clear error on successful validation
    setStep(step + 1);
  };

  const handleKitchenClose = () => {
    closeLightbox();
    if (preview) revokePreviewUrls([preview]);
    setStep(1);
    setResponses({});
    setPreview(null);
    setFile(null);
    KitchenToggle();
  };

  return (
    <>
    <Modal show={Kitchen} onHide={handleKitchenClose} centered className="modal-getstarted">
      <button
        type="button"
        className="rs-lc-close"
        onClick={handleKitchenClose}
        aria-label="Close"
      >
        <Icon icon="tabler:x" width={22} height={22} />
      </button>
      <Modal.Body className="text-center rs-lc-body">
        {/* Progress Bar */}
        <div className="peronalInfoProgress mb-4">
          {[...Array(totalSteps)].map((_, index) => (
            <span
              key={index}
              className={index < step ? "done" : ""}
              onClick={() => {
                if (index + 1 < step) {
                  setStep(index + 1);
                }
              }}
              style={{ cursor: index + 1 < step ? "pointer" : "default" }}
            ></span>
          ))}
        </div>

        {/* Steps Content */}
        {[
          { text: "Do you have architectural plans or drawings?", icon: homeIcon },
          { text: "Do you already have a building permit?", icon: compliantIcon },
          { text: "Are you working with a designer?", icon: interiordesignerIcon },
          { text: "Will you be selling this home?", icon: paymentIcon },
          { text: "Provide a brief description of your project.", icon: projectDescIcon },
        ].map((item, index) => (
          <div key={index} className={`personalInfosteps ${step === index + 1 ? "d-block" : "d-none"}`}>
            <h4>Tell Us About Your Project</h4>
            <Image className="personalIcon" src={item.icon} alt="" />
            <h3>{item.text}</h3>
            {step !== 5 && 
            <div className="yesnobtn_box">
            <Link
              className={`yesnobtn ${responses[step] === "yes" ? "active" : ""}`}
              onClick={() => handleYesNoClick("yes")}
            >
              Yes
            </Link>
            <Link
              className={`yesnobtn ${responses[step] === "no" ? "active" : ""}`}
              onClick={() => handleYesNoClick("no")}
            >
              No
            </Link>
          </div>
          }
            
            { step === 5 && (
              <Form className="text-start mt-2">
                <Form.Group className="form-group">
                  <Form.Label>Write here</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={5}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    isInvalid={descriptionError}
                  />
                  <Form.Control.Feedback type="invalid">
                    Description is required.
                  </Form.Control.Feedback>
                </Form.Group>
              </Form>
            )}
            {error && <p className="text-danger">{error}</p>}
            {/* Conditionally show upload field */}
            {step === 1 && responses[step] === "yes" && !preview && (
              <div
                className="additional-div rs-re-upload-zone mt-2"
                onDragOver={(e) => e.preventDefault()}
                onDrop={handleDropArchitectural}
              >
                <Form.Label htmlFor="uploadphotos">
                  <Icon icon="garden:upload-fill-16" width={24} height={24} />
                  <h6>Upload photos</h6>
                  <p className="mb-0">Drag and drop here, or click to browse</p>
                </Form.Label>
                <Form.Control
                  type="file"
                  name="uploadphotos"
                  id="uploadphotos"
                  accept="image/png,image/jpeg,image/webp,image/heic"
                  className="d-none"
                  onChange={handleFileChange}
                />
              </div>
            )}
            {step === 1 && responses[step] === "yes" && preview && (
              <div className="text-center rs-re-preview-grid mt-3">
                <div className="uploadRemove_box rs-re-step-preview">
                  <ClickablePhoto
                    src={preview}
                    alt="Architectural plan preview"
                    onView={openLightbox}
                  />
                  <button
                    type="button"
                    className="close-preview"
                    onClick={handleRemoveImage}
                    aria-label="Remove photo"
                  >
                    <Icon icon="tabler:x" width={18} height={18} />
                  </button>
                </div>
                <p className="rs-re-upload-confirm">Photo uploaded — click to view full size, or tap × to replace</p>
              </div>
            )}
          </div>


        ))}

        {/* Buttons */}
        <div className="d-flex align-items-center justify-content-center gap-2 flex-wrap mt-4">
          {step < totalSteps ? (
            <Link
              className={`nextmodal_btn ${isNextDisabled ? "disabled" : ""}`}
              onClick={handleNext}
              style={{ pointerEvents: isNextDisabled ? "none" : "auto", opacity: isNextDisabled ? 0.5 : 1 }}
            >
              Next <Icon icon="mynaui:arrow-right" width="24" height="24" />
            </Link>
          ) : (
            <Link className="nextmodal_btn" onClick={submitBtn}>Next <Icon icon="mynaui:arrow-right" width="24" height="24" /></Link>
          )}
        </div>
      </Modal.Body>
    </Modal>
    </>
  );
};

export default KitchenModal;
